import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AmbassadorsProvider } from "../../hooks/useAmbassadors";
import Nav from "./components/Nav";
import Ambassadors from "./components/Ambassadors";
function App() {
    return (_jsx(AmbassadorsProvider, { children: _jsxs("div", { className: "relative h-full w-full", children: [_jsx(Nav, {}), _jsx(Ambassadors, {})] }) }));
}
export default App;
